import { incomeSwitchOptions } from "@/utils/incomeTypes";
import type { IncomeTypeConfig } from "@/utils/incomeTypes";
import { Button, Space } from "antd";
import { setIcons ,getTimeFormat} from "@/utils/common";

import { deviceTypeOptions } from "@/utils/enums";
// import { useState } from "react";
// helps.tsx (1-230)
/**
 * 收益配置开关枚举（通用）
 * 0: 开启，1: 关闭
 */
export enum ProfitSwitchEnum {
  OPEN = 0, // 开启
  CLOSE = 1, // 关闭
}

export const getProfitSwitchText = (status: number): string => status === ProfitSwitchEnum.OPEN ? '开启' : '关闭';

// 流水收益分佣类型选项
const deviceFlowRewardTypeOptions = [
  {
    label: "通用模式",
    value: 0,
  },
  {
    label: "自定义模式",
    value: 1,
  },
  {
    label: "不分佣",
    value: 2,
  },
];

export const  formTab = [
  // {
  //   label: "用户业务ID",
  //   name: "userBusinessId",
  //   type: "input",
  // },
  {
    label: "账号",
    name: "mobile",
    type: "input",
  },
  {
    label: "昵称",
    type: "input",
    name: "nickName",

  },

  {
    label: "时间范围",
    name: "rangePicker",
    type: "rangePicker",
    width: "380px",
    params: {
      defaultTimer: [
      ],
    },
  },
]

// 防抖函数
let searchTimer: NodeJS.Timeout | null = null;

export const modalFormTab = (incomeTypes: IncomeTypeConfig, userList?: any[], getUserList?: any) => [
  {
    label: "提转用户",
    name: "userId",
    type: "select",
    options: userList,
    labelCol: { span: 4, offset: 0 },
    wrapperCol: { span: 18, offset: 0 },
    params: {
      onSearch: (val: string) => {
        if (searchTimer) clearTimeout(searchTimer);
        searchTimer = setTimeout(() => { if (val.trim()) getUserList(val); }, 300);
      },
      allowClear: true,
      showSearch: true,
      filterOption: false,
      placeholder: "请输入用户账号搜索",
      notFoundContent: userList?.length === 0 ? "暂无数据" : "请输入关键字搜索",
      style: { width: "80%" },
    },
    width: "100%",
    rules: [{ required: true, message: "请选择用户账号" }],
  },
  {
    label: "可提现类型",
    type:'text',
  },
  {
    label: "",
    name: "withdrawKeys",
    type: "checkboxGroup",
    options: incomeSwitchOptions(incomeTypes, "withdraw"),
    width: "100%",
    labelCol: { span: 24, offset: 0 },
    wrapperCol: { span: 24, offset: 0 },
  },
  {
    label: "可转赠类型",
    type:'text',
  },

  {
    label: "",
    name: "transferKeys",
    type: "checkboxGroup",
    options: incomeSwitchOptions(incomeTypes, "transfer"),
    width: "100%",
    labelCol: { span: 24, offset: 4 },
    wrapperCol: { span: 24, offset: 0 },
  },
  // {
  //   label: "备注",
  //   name: "remark",
  //   type: "textArea",
  //   labelCol: { span: 10, offset: 0 },
  //   width: "320px",
  // },
];


export const columns = ({
  setModalFormData,
  setOpen,
  deleteCommissionData,
  editCommissionData,
  incomeTypes
}: {
  incomeTypes: IncomeTypeConfig;
  setModalFormData: any;
  setOpen: any;
  deleteCommissionData: any;
  editCommissionData: any;
}) => [
  {
    title: "用户ID",
    dataIndex: "userId",
    key: "userId",
  },

  {
    title: "昵称",
    dataIndex: "nickName",
    key: "nickName",
  },
  {
    title: "账号",
    dataIndex: "mobile",
    key: "mobile",
  },
  {
    title: '提现类型',
    align: 'center' as const,
    children: incomeSwitchOptions(incomeTypes, "withdraw").map((option) => ({
      title: option.label, dataIndex: option.value, key: option.value, width: 100,
      render: (value: number | undefined) => <span style={{ color: value === 0 ? '#52c41a' : '#ff4d4f' }}>{getProfitSwitchText(value ?? 1)}</span>,
    })),
  },
  {
    title: '转赠类型',
    align: 'center' as const,
    children: incomeSwitchOptions(incomeTypes, "transfer").map((option) => ({
      title: option.label, dataIndex: option.value, key: option.value, width: 100,
      render: (value: number | undefined) => <span style={{ color: value === 0 ? '#52c41a' : '#ff4d4f' }}>{getProfitSwitchText(value ?? 1)}</span>,
    })),
  },


  // {
  //   title: "备注",
  //   dataIndex: "remark",
  //   key: "remark",
  // },

  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
    render: (val: string) => {
      return <div>{getTimeFormat(val)}</div>
    }
  },
  // {
  //   title: "更新时间",
  //   dataIndex: "updateTime",
  //   key: "updateTime",
  // },
  {
    title: "操作",
    dataIndex: "id",
    key: "operation",
    fixed: "right",
    width: "120px",
    render: (val: string, rows: any) => (
      <Space>
        <Button
          size="small"
          icon={setIcons("EditOutlined")}
          type="text"
          onClick={(e) => {
            editCommissionData(rows);
          }}
        >
          修改
        </Button>
        <Button
          size="small"
          icon={setIcons("DeleteOutlined")}
          type="text"
          onClick={(e) => {
            deleteCommissionData(rows.id);
          }}
        >
          删除
        </Button>
      </Space>
    ),
  },
];


